"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Box = _interopRequireDefault(require("./Box"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("./theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      overflow: hidden;\n      transition: ", " background-size;\n      will-change: background-size;\n      background-size: auto ", "%;\n      &:hover {\n        background-size: auto\n          ", "%;\n      }\n      ", " {\n        transition: none;\n        background-size: cover !important;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  ", " ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var src = function src(props) {
  return props.src && {
    backgroundImage: "url(".concat(props.src, ")")
  };
};

var height = function height(props) {
  return props.height && {
    height: props.height
  };
};

var BackgroundImage = (0, _styledComponents["default"])(_Box["default"])(_templateObject(), src, height, function (props) {
  return props.scale && (0, _styledComponents.css)(_templateObject2(), function (_ref) {
    var theme = _ref.theme;
    return theme.transition;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.scaleFactor * 100;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return (theme.scaleFactor + 1 / 16) * 100;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.mediaQueries.reduceMotion;
  });
});
BackgroundImage.displayName = 'BackgroundImage';
BackgroundImage.propTypes = {
  /** background-image url */
  src: _propTypes["default"].string.isRequired,

  /** add hover animation */
  scale: _propTypes["default"].bool,

  /** accessible label */
  'aria-label': _propTypes["default"].string.isRequired
};
BackgroundImage.defaultProps = {
  theme: _theme["default"],
  bg: 'smoke'
};
var _default = BackgroundImage;
exports["default"] = _default;